export default [
  {
    path: '/modules/report',
    redirect: '/modules/report/administrative',
    name: 'reportPageAdm',
    component: () => import('@/views/modules/report/Report.vue'),
    meta: {
      action: 'ROLE_ADM_CONSULTAR',
      resource: 'ACL',
      pageTitle: 'Relatórios',
      breadcrumb: [
        {
          text: 'Administrative',
        },
      ],
    },
    children: [
      {
        path: 'administrative',
        name: 'administrative',
        component: () => import('@/views/modules/report/Report.vue'),
        meta: {
          pageTitle: 'Relatórios',
          action: 'ROLE_ADM_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Módulo Administrativo | Relatórios',
            },
          ],
        },
      },
    ],
  },
]
